import {
  DeleteCardProgress,
  MutateVariantResponse,
  VariantCardContextState,
} from 'modules/experiments/types';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { MutatedExperimentVariant } from '../takeover/types';

export const initialVariantCardContextState: VariantCardContextState = {
  cardIndex: 0,
  variant: {} as MutatedExperimentVariant,
  templateErrors: [],
  deletingCard: DeleteCardProgress.NOT_STARTED,
  updatingCard: false,
  renamingCard: false,
  isCardSelected: false,
  isCardInEditMode: false,
  isCardInPreviewMode: false,
  deleteCard: () => new Promise((resolves) => resolves()),
  editCard: noop,
  renameCard: () => new Promise((resolves) => resolves()),
  selectCard: noop,
  updateCard: () => new Promise((resolves) => resolves({} as MutateVariantResponse)),
};

export const VariantCardContext = createContext(initialVariantCardContextState);

export const useVariantCardContext = () => useContext(VariantCardContext);
